export enum OutOfServiceReasonCode {
  /**
   * **Significato:** La memoria fiscale interna (DGFE o Giornale di Fondo Elettronico)
   * è completamente piena.
   *
   * **Quando si usa:** Questo codice blocca la cassa e impedisce l'emissione di
   * qualsiasi scontrino. Viene selezionato dal tecnico autorizzato poco prima di
   * procedere alla sostituzione fisica della memoria o del registratore stesso.
   */
  MemoryFull = 600,

  /**
   * **Significato:** Il dispositivo viene messo fuori servizio per una motivazione
   * generica e residuale non coperta dagli altri codici standard.
   *
   * **Quando si usa:** Si applica in casi particolari, ad esempio durante le
   * procedure tecniche di defiscalizzazione definitiva, cessazione
   * dell'attività commerciale, oppure per variazioni societarie straordinarie che
   * richiedono il blocco del punto cassa.
   */
  Other = 601,

  /**
   * **Significato:** Il registratore di cassa ha subito un guasto tecnico
   * hardware o software che ne impedisce il corretto funzionamento o
   * la trasmissione dei dati.
   *
   * **Quando si usa:** Si seleziona quando la macchina si rompe (es. stampante
   * guasta, display rotto, errore di checksum interno).
   * L'invio di questo codice notifica l'AdE e giustifica legalmente la
   * mancata trasmissione dei corrispettivi, obbligando l'esercente ad
   * annotare le vendite sul registro di emergenza cartaceo fino alla
   * riparazione del tecnico.
   */
  Malfunction = 607,

  /**
   * **Significato:** Il dispositivo è perfettamente funzionante,
   * ma viene spento temporaneamente per un periodo prolungato.
   *
   * **Quando si usa:** È il codice standard per ferie, chiusure stagionali o
   * inattività superiori a 12 giorni.
   * Serve a comunicare al fisco che l'assenza di invii telematici serali
   * è dovuta alla legittima chiusura del negozio e non a un'evasione o a un guasto.
   */
  WarehouseOrInactivity = 608,
}
